import script from "./AgreeTermsContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreeTermsContent.vue?vue&type=script&setup=true&lang=js"

import "./AgreeTermsContent.vue?vue&type=style&index=0&id=4aac613a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aac613a"]])

export default __exports__